<ion-col class="no-padding" [ngClass]="getCustomCssWrapper()">
  <mat-progress-bar *ngIf="init" [ngClass]="getCustomCss()" mode="determinate" [value]="config.value">
  </mat-progress-bar>
</ion-col>